import React from 'react';

interface ServiceStatusCardProps {
    carPlate: string;
}

const DeliveredStatusCard: React.FC<ServiceStatusCardProps> = ({ carPlate }) => {
    return (
        <div className="row d-flex flex-column-reverse flex-md-row">
            <div className="col-md-6 my-md-5">
                <h1>Vehículo entregado</h1>
                <h2>Placa: {carPlate}</h2>
                <p>Tu vehículo ha sido entregado exitosamente. Gracias por usar nuestro servicio de valet.</p>
                <div className="alert alert-success">
                    <strong>¡Servicio completado!</strong> Esperamos verte pronto.
                </div>
            </div>
            <div className="col-md-6 my-5 p-1 d-flex justify-content-center align-items-center" style={{ backgroundColor: "#ffffff44", borderRadius: '8px' }}>
                <img src="/assets/delivered_car.svg" alt="Vehículo entregado" />
            </div>
        </div>
    );
};

export default DeliveredStatusCard;
